import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/Logo_Dojo.png'
import _imports_1 from '../assets/Tori.png'


const _withScopeId = n => (_pushScopeId("data-v-2032fc34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login_page" }
const _hoisted_2 = { class: "menu-bar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Dojo Logo",
  src: _imports_0
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "menu-btn",
  href: "https://drive.google.com/open?id=17LQ60V8D14bdGvmDWktkKopFEWzcmqlv",
  target: "_blank"
}, "LIVRET DE RÈGLES", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "menu-btn",
  href: "https://youtu.be/4qBFUyZrpcQ",
  target: "_blank"
}, "VIDÉO DE RÈGLES", -1))
const _hoisted_6 = {
  key: 0,
  class: "active-page"
}
const _hoisted_7 = { class: "menu-pop-up__page" }
const _hoisted_8 = {
  key: 1,
  class: "active-page"
}
const _hoisted_9 = { class: "menu-pop-up__page" }
const _hoisted_10 = {
  key: 2,
  class: "active-page"
}
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"tori-and-logo\" data-v-2032fc34><img alt=\"Tori\" class=\"tori-img\" src=\"" + _imports_1 + "\" data-v-2032fc34><img alt=\"Dojo Logo\" class=\"logo-img\" src=\"" + _imports_0 + "\" data-v-2032fc34><p class=\"subtitle\" data-v-2032fc34>LE DUEL DES MAÎTRES</p></div><div class=\"horizontal-bar\" data-v-2032fc34></div>", 2)
const _hoisted_13 = {
  key: 0,
  class: "login-panel-display right-panel"
}
const _hoisted_14 = {
  key: 1,
  class: "right-panel welcome-panel"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "DEVENEZ UN HONORABLE MAÎTRE DE DOJO EN REMPORTANT VOS DUELS", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Dojo est un jeu de cartes, de bluff et de stratégie.", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Envoyez vos Prodiges au combat,", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Déchaînez leurs Talents et leurs Maîtrises,", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Remportez le titre du plus honorable Maître de Dojo !", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Pour tout retour, avis ou question, n'hésitez pas à nous écrire à "),
    /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "dojo.duel@outlook.fr")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Credits = _resolveComponent("Credits")!
  const _component_Faq = _resolveComponent("Faq")!
  const _component_LoginPanel = _resolveComponent("LoginPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", {
        class: _normalizeClass([{'menu-btn--active': _ctx.currentPage === 'faq'}, "menu-btn"]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.change_page('faq')))
      }, "FAQ ", 2),
      _createElementVNode("div", {
        class: _normalizeClass([{'menu-btn--active': _ctx.currentPage === 'credits'}, "menu-btn"]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.change_page('credits')))
      }, " CRÉDITS ", 2)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([{'play-btn--active': _ctx.currentPage === 'play'}, "play-btn"]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.change_page('play')))
    }, "JOUER ", 2),
    (_ctx.currentPage === 'credits')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Credits)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentPage === 'faq')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Faq)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentPage === 'play')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          (_ctx.displayed_panel === 'lobby')
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_LoginPanel)
              ]))
            : _createCommentVNode("", true),
          (_ctx.displayed_panel === 'welcome')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _hoisted_15,
                _hoisted_16,
                _hoisted_17,
                _hoisted_18,
                _hoisted_19,
                _createElementVNode("div", {
                  class: "welcome-button",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.displayLobby && _ctx.displayLobby(...args)))
                }, "ENTRER")
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _hoisted_20
  ]))
}